module.exports = __webpack_public_path__ + "static/media/logo.e12ae6a6.png";